module.exports = __webpack_public_path__ + "img/logo-icoin-app.cab88bad.png";